import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_prov_other_insurance_to_wrkrs_who_are_not_covered'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_prov_other_insurance_to_wrkrs_who_are_not_covered',
  name: 'Does the facility provide other insurance to workers who are not covered by legally required social insurance or social security programs?\r\r\n \r\r\n',
  description:
    'The intent of this question is to understand if the facility provides social insurance/ social security that is not legally required and if the facility is providing this "other" insurance to workers who are not covered by legally required social insurance/ social security. \r\r\n\r\r\nFor example, private insurance like Group Accident Insurance in China is a type of other insurance that is not legally required.\r\r\n\r\r\nIf the facility is covering all workers, as legally required, for all types of legally required social insurance/ social security, answer Not Applicable. ',
  meta: {},
  fieldTypeId: 'SELECT_WITH_FOLLOW_UP',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
      followUp: {
        fieldType: 'NUMBER',
        text: 'If yes, how many workers are covered by this other insurance?\n',
        externalIds: [
          {
            id: 'wb-wage-87f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'object',
        properties: {
          value: {
            type: 'string',
            enum: ['YES', 'NO', 'NOT_APPLICABLE'],
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['value', 'followUp'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-86',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9240,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
